import AddNewDocument from './AddNewDocument';
export { AddNewDocument };
export default AddNewDocument;
